import { useRequestURL, useRoute } from '#imports'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

type FilterClickPayload = {
  zone: string
  name: string
  value?: string | number
  position?: number
}

export function useFilterTracking() {
  const { trackClick } = useTracking()
  const route = useRoute()
  const { origin } = useRequestURL()

  function trackFilterClick(payload: FilterClickPayload) {
    const pageParams: Record<string, string> = {
      url: `${origin}${route.fullPath}`,
    }

    const { slugV2, uuid } = route.params

    if (typeof slugV2 === 'string' && slugV2) {
      pageParams.slugV2 = slugV2
    }

    if (typeof uuid === 'string' && uuid) {
      pageParams.uuid = uuid
    }

    const rawQuery = route.query.q
    const query = Array.isArray(rawQuery) ? rawQuery[0] : rawQuery

    if (typeof query === 'string' && query) {
      pageParams.query = query
    }

    trackClick({ ...pageParams, ...payload })
  }

  return { trackFilterClick }
}
